module.exports = __webpack_public_path__ + "static/img/border.d32ab21.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature/border.png
// module id = hVwb
// module chunks = 7